import { getAppUserAccess } from "global/auth/appUserAccessPermissions"
import { useContext } from "react"
import { AppUserContext } from "../AppUserContext"

export const useAppUserAccess = () => {
  const appUserContext = useContext(AppUserContext)
  const { appUser_state } = appUserContext ?? {}
  const { appUsers } = appUser_state ?? {}
  const appUserAccess = getAppUserAccess(appUsers)
  return appUserAccess
}